import SVGIcon from './SVGIcon';
import {
  NOTCHUP_TWITTER_URL,
  NOTCHUP_LINKEDIN_URL,
  NOTCHUP_INSTAGRAM_URL,
  TERMS_CONDITION_URL,
  PRIVACY_POLICY_URL,
  COOKIE_POLICY_URL,
  ACCEPTABLE_POLICY_URL,
  HELP_CENTRE_URL,
} from '../lib/constants';

const SOCIAL_LINKS = [
  {
    name: 'Twitter',
    url: NOTCHUP_TWITTER_URL,
    icon: '/images/twitter.svg',
  },
  {
    name: 'LinkedIn',
    url: NOTCHUP_LINKEDIN_URL,
    icon: '/images/linkedin.svg',
  },
  {
    name: 'Instagram',
    url: NOTCHUP_INSTAGRAM_URL,
    icon: '/images/instagram.svg',
  },
];

const FOOTER_LINKS = [
  {
    name: 'Terms',
    url: TERMS_CONDITION_URL,
  },
  {
    name: 'Privacy',
    url: PRIVACY_POLICY_URL,
  },
  {
    name: 'Cookie',
    url: COOKIE_POLICY_URL,
  },
  {
    name: 'Acceptable',
    url: ACCEPTABLE_POLICY_URL,
  },
  {
    name: 'Help',
    url: HELP_CENTRE_URL,
  },
];

interface FooterProps {
  readonly className?: string;
}

export default function Footer({ className = '' }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className={`bg-white grid grid-cols-1 lg:grid-cols-3 gap-2 lg:gap-0 py-3 px-5 lg:px-8 text-action-900 flex-shrink-0 z-40 ${className}`}
    >
      {/* Copyright */}
      <div className="flex justify-center lg:justify-start items-center">
        <p className="text-mono-700 opacity-50 small-text text-center lg:text-left">
          © xDitto {currentYear} - All rights reserved.
        </p>
      </div>

      {/* Footer Links */}
      <div className="flex justify-center items-center">
        <ul className="flex flex-wrap justify-center gap-4">
          {FOOTER_LINKS.map((link) => (
            <li key={link.name}>
              <a
                href={link.url}
                target="_blank"
                rel="noreferrer"
                className="text-mono-700 opacity-50 small-text hover:opacity-75 transition-opacity"
              >
                {link.name}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* Social Links */}
      <div className="flex justify-center lg:justify-end items-center">
        <ul className="flex gap-4">
          {SOCIAL_LINKS.map((social) => (
            <li key={social.name}>
              <a
                href={social.url}
                target="_blank"
                rel="noreferrer"
                title={social.name}
                className="flex items-center justify-center w-3 h-3 opacity-50 hover:opacity-75 transition-opacity"
              >
                <SVGIcon
                  src={social.icon}
                  className="w-3 h-3"
                  fillColor="var(--color-action-900)"
                />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
}
